import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "nb-button transition-colors disabled:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "nb-button--primary",
        destructive:
          "nb-button--danger",
        outline: "nb-button--outline",
        secondary: "nb-button--secondary",
        ghost: "nb-button--ghost",
        link: "nb-button--link underline-offset-4",
      },
      size: {
        default: "",
        sm: "nb-button--sm",
        lg: "nb-button--lg",
        icon: "nb-button--icon",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  },
);

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Button, buttonVariants };
